import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { BillOut } from "../api/bills";

/** Сметка, чието закриване още чака фискалния принтер — модалът „Закрий" вече
 *  е затворен и кутийката на масата се върти (docs/ordering.md §Поток:
 *  закриване, плащане, фискализация). */
export type ClosingBill = {
  billId: number;
  /** Сметката в момента на натискане на „Закриване" — държи кутийката в
   *  списъка, каквото и да връща `GET /bills` междувременно (при режим
   *  „никога" закритата сметка изчезва от него веднага). null — сметка извън
   *  списъка с маси („Фискализирай" от „Възстановяване"). */
  snapshot: BillOut | null;
  /** Кой е натиснал — снимката се връща в списъка само на него; заключването
   *  на масата важи за всички на терминала (`payment/closingBills.ts`). */
  userId: number | null;
};

type BillState = {
  selectedBillId: number | null;
  closingBills: ClosingBill[];
};

const initialState: BillState = {
  selectedBillId: null,
  closingBills: [],
};

const billSlice = createSlice({
  name: "bills",
  initialState,
  reducers: {
    setSelectedBillId(state: BillState, action: PayloadAction<number | null>) {
      state.selectedBillId = action.payload;
    },
    billClosingStarted(state: BillState, action: PayloadAction<ClosingBill>) {
      state.closingBills = [
        ...state.closingBills.filter(
          (closing) => closing.billId !== action.payload.billId,
        ),
        action.payload,
      ];
    },
    billClosingFinished(state: BillState, action: PayloadAction<number>) {
      state.closingBills = state.closingBills.filter(
        (closing) => closing.billId !== action.payload,
      );
    },
  },
});

export const { setSelectedBillId, billClosingStarted, billClosingFinished } =
  billSlice.actions;

export default billSlice.reducer;
